module.exports = __webpack_public_path__ + "img/145.51d3eae8.jpg";